module.exports = __webpack_public_path__ + "media/images/first_aid-28d345d4eac17b2383119fbde174a8cf.png";